﻿import State from './State.js';
import ScoreCalculator from './ScoreCalculator.js';
export default class StateShowNonDealerHand extends State {
    constructor(context) {
        super(context);
        this.name = 'showNonDealerHand';
        this.calc = new ScoreCalculator();
    }
    setup() {
        this.context.playerTurn = "";
        this.showAndScore();

    }
    action(command, value, player) {
        switch (command) {
            case "nextShow": return this.next(player); break;
            case "next": return this.next(player); break;
            default: return this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        actions.push({ command: "nextShow", value: null });
        actions.push({ command: "next", value: null });
        return actions;
    }
    next() {
        this.context.setState("showDealerHand");
        return true;
    }
    showAndScore(){
        this.showNonDealersHand();
        this.scoreNonDealersHand();
    }
    showNonDealersHand() {
        let dealer = this.context.dealer;
        if(!dealer) return;
        let nonDealer = (dealer === "player1") ? "player2" : "player1";
        let nonDealerHandName = nonDealer == "player1" ? "handShow1" : "handShow2";

        //message
        this.context.messagePlayer1 = "";
        this.context.messagePlayer2 = "";

        if (nonDealer === "player1") this.context.messagePlayer1 = "Hand";
        if (nonDealer === "player2") this.context.messagePlayer2 = "Hand";



        //pull cards back from discard pile and place back in hand to score
        //let playedCards = this.context.getPile("played");
        let playersCards = this.context.getCardsByOwner(nonDealer);
        for (let i = 0; i < playersCards.length; i++) {
            let card = playersCards[i];
            card.showfront = false;
            this.context.addToPile(card, nonDealerHandName, "system");
        }
        this.context.sortPile(nonDealerHandName);
    }

    scoreNonDealersHand() {
        let dealer = this.context.dealer;
        let nonDealer = (dealer === "player1") ? "player2" : "player1";
        
        let playersCards = this.context.getCardsByOwner(nonDealer);

        //starter card
        let starterCard = this.context.getStarterCard();

        //The non dealer scores his hand first
        let pointsNonDealersHand = this.calc.scoreHand(starterCard, playersCards, nonDealer);
        this.context.awardPointsArray(pointsNonDealersHand);

        //get total points for array
        let totalPoints = pointsNonDealersHand.reduce(function (total, pointLog) {
            return total + pointLog["points"];
        }, 0);

        //send totalPoints as message for UI to show
        this.context.sendEvent("handPoints", totalPoints + " Hand", nonDealer);

        //todo: save hand points or just pull from point log to display. seems like there is no point log
        this.context.sendEvent("message", " Non Dealer's Hand", nonDealer);
    }


    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}